import { render } from "./ArticlesPanel.vue?vue&type=template&id=ccf223d2&scoped=true"
import script from "./ArticlesPanel.vue?vue&type=script&lang=js"
export * from "./ArticlesPanel.vue?vue&type=script&lang=js"

import "./ArticlesPanel.vue?vue&type=style&index=0&id=ccf223d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf223d2"]])

export default __exports__